import React, { memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { ResponsiveType } from '@sport1/react-elements/Types'
import { ImageSizeTypes } from '../ImageInterfaces'
import Image from '..'
import PlayerImageFallback from './Fallback'
import { TestID } from '@/utils/PropTypesDefinitions'

type PlayerImageProps = {
    imageUrl?: string
    alt?: string
    width: ResponsiveType<number>
    size: ImageSizeTypes
    radiusType?: 'none' | 'circled' | 'rounded'
} & TestID

const PlayerImage = ({ imageUrl, alt, size, width, testID }: PlayerImageProps): ReactElement => (
    <Grid testID={`${testID}-playerimage-grid`} noExpand center width={width} height={width}>
        {imageUrl ? (
            <Image
                width={Array.isArray(width) ? '100%' : width}
                size={size}
                aspectRatio="1:1"
                radiusType="none"
                imageUrl={imageUrl}
                testID={`${testID}-playerimage`}
                alt={alt}
            />
        ) : (
            <PlayerImageFallback
                width={Array.isArray(width) ? '100%' : width}
                testID={`${testID}-playerfallback`}
            />
        )}
    </Grid>
)

export default memo(PlayerImage)
